// Umami v3 — отправка событий через правильный API
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WEBSITE_ID = '6310753d-4b4a-4e33-a3f3-918eb19d185d';
const ENDPOINT = 'https://umami.jobmd.top/api/send';

function sendPageview(url, referrer = '') {
  try {
    // Umami v3 принимает только type: "event", "identify", "performance"
    // pageviews отправляются как event
    const payload = {
      type: 'event',
      payload: {
        website: WEBSITE_ID,
        url,
        referrer,
        hostname: 'jobmd.top',
        language: navigator.language || 'ru',
        screen: `${window.screen.width}x${window.screen.height}`,
        title: document.title,
      },
    };

    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, JSON.stringify(payload));
    } else {
      fetch(ENDPOINT, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    // тихо
  }
}

export default function useUmami() {
  const location = useLocation();

  useEffect(() => {
    // Первый pageview после загрузки
    const timer = setTimeout(() => {
      sendPageview(location.pathname + location.search);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);
}
